import { Setup } from './Setup';
import { initDocumentShop } from './DocumentShop';
import { initAlerts } from '../Functions/Alert';

const MODAL_QUERY_SELECTOR = '#js-modal-vrs-documentshop-basket';
const ARTICLE_LIST_QUERY_SELECTOR = '#js-document-modal-articles';
const CONFIRM_ARTICLE_LIST_QUERY_SELECTOR = '#js-document-modal-confirmarticles';
const SUBMIT_BUTTON_QUERY_SELECTOR = '#js-document-modal-submit-button';

export class Basket {

  private basketForm: HTMLElement | undefined;

  initBasket() {
    // article confirmation are handled after basket-load, because at this point, we have all data available
    this.tabHandling();
    this.submitHandling();
    this.initListener();
  }

  /**
   * put result in basket step 1 and step 3 (confirmation)
   */

  private getBasketListContent() {
    const articleList = document.querySelector(ARTICLE_LIST_QUERY_SELECTOR)!;
    const confirmArticleList = document.querySelector(CONFIRM_ARTICLE_LIST_QUERY_SELECTOR)!;
    articleList.innerHTML = '...';
    const language = document.querySelector('html')!.getAttribute('lang')!;
    const url = Setup.API_BASE_PATH + 'basketListContent' + '?language=' + language;

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(articleListsHtml => {
        articleList.innerHTML = articleListsHtml.articles;
        confirmArticleList.innerHTML = articleListsHtml.confirmationArticles;

        const submitButtonArticleList = document.getElementById('submit-button__article-list')! as HTMLButtonElement;
        submitButtonArticleList.disabled = (articleListsHtml.basketArticleCount === 0);

        // init needed functions
        this.initModalListener();
        initAlerts();
      });
  }

  private tabHandling(): void {
    // addEventListener to all tabs
    const tabStepLinks = document.getElementsByClassName('js-basket-modal-tab-step-link');
    for (let i = 0; i < tabStepLinks.length; i++) {
      tabStepLinks[i].addEventListener('click', event => {
        // second step has to handle form validation
        if (i === 2 && !this.handleAddressConfirmation(event)) {
          return;
        }

        this.showTab(event.target as HTMLElement);
      });
    }
  }

  private submitHandling(): void {
    const basketForm: HTMLFormElement | null  = document.getElementById('form-basket-articles') as HTMLFormElement;
    if (!basketForm) {
      return;
    }
    basketForm.addEventListener('submit', event => {
      const submitButton = document.querySelector(SUBMIT_BUTTON_QUERY_SELECTOR)! as HTMLButtonElement;
      submitButton.disabled = true;
    });
  }

  private showTab(tabStepLink: HTMLElement): void {
    // show selected js-tab-content und hide other js-tab-content
    // set also active-classes to tabs on same way

    // show relevant js-tab-content
    const tabContents = document.getElementsByClassName('js-tab-content');
    for (let y = 0; y < tabContents.length; y++) {
      if (tabStepLink.getAttribute('data-target') === tabContents[y].id) {
        tabContents[y].classList.remove('hide');
      } else {
        tabContents[y].classList.add('hide');
      }
    }

    // put relevant tab active-class
    const tabs = document.getElementsByClassName('js-basket-modal-tab');
    for (let z = 0; z < tabs.length; z++) {
      if (tabStepLink.getAttribute('data-target') === tabs[z].getAttribute('data-target')) {
        tabs[z].classList.add('active');
      } else {
        tabs[z].classList.remove('active');
      }
    }
  }

  private handleAddressConfirmation(event): boolean {
    const basketForm  = document.getElementById('form-basket-articles') as HTMLFormElement;
    if (!basketForm.reportValidity()) {
      event.preventDefault();
      return false;
    }

    // ConfirmData Element has solid structure to combine with form data
    // e.g.: FormData id 'form-basket-forename' is ConfirmData id 'basket-confirmdata-forename'
    // for given input, find equivalent confirm-element and set it

    // not all elements have confirmation data (e.g. like policy), but we need it for form validation
    const formElements = document.getElementsByClassName('js-basket-address-data');
    for (let i = 0; i < formElements.length; i++) {
      const formElement = formElements[i] as HTMLInputElement;
      const confirmElement = document.getElementById(formElement.id.replace('form-basket-', 'basket-confirmdata-'));
      if (confirmElement) {
        confirmElement.innerHTML = formElement.value;
      }
    }

    return true;
  }

  private openModal() {
    this.getBasketListContent();
    const basketModal = document.querySelector(MODAL_QUERY_SELECTOR)!;
    basketModal.classList.add('open');

    // when open, show always first tab
    const modalTabs = document.getElementsByClassName('js-basket-modal-tab');
    this.showTab(modalTabs[0] as HTMLElement);
  }

  private initListener(): void {
    // openBasketModal
    const buttonOpenBasketModal = document.getElementsByClassName('js-button-open-basket-modal');
    for (let i = 0; i < buttonOpenBasketModal.length; i++) {
      buttonOpenBasketModal[i].addEventListener('click', event => {
        this.openModal();
      });
    }

    // closeBasketModal
    const buttonCloseBasketModal = document.getElementsByClassName('js-button-close-basket-modal');
    for (let i = 0; i < buttonCloseBasketModal.length; i++) {
      buttonCloseBasketModal[i].addEventListener('click', event => {
        const basketModal = document.querySelector(MODAL_QUERY_SELECTOR)!;
        basketModal.classList.remove('open');
        let basketForm: HTMLFormElement | null;
        if (!this.basketForm) {
          basketForm = document.getElementById('form-basket-articles') as HTMLFormElement;
        } else {
          basketForm = this.basketForm as HTMLFormElement;
        }

        if (basketForm) {
          basketForm.removeEventListener('submit', this.handleSubmitBasketFormListenerFunction);
        }
      });
    }
  }

  private initModalListener(): void {
    /**
     * put result in basket step 1 and step 3 (confirmation)
     */
      // changeBasketArticle
    const changeBasketArticleSelects = document.getElementsByClassName('js-select-change-basket-article');
    for (let i = 0; i < changeBasketArticleSelects.length; i++) {
      changeBasketArticleSelects[i].addEventListener('change', event => {
        const documentUid = changeBasketArticleSelects[i].getAttribute('data-article-uid')!;
        const language = changeBasketArticleSelects[i].getAttribute('data-article-language')!;
        const quantity = (event.target as HTMLSelectElement).value;

        const articleList = document.querySelector(ARTICLE_LIST_QUERY_SELECTOR)!;
        const confirmArticleList = document.querySelector(CONFIRM_ARTICLE_LIST_QUERY_SELECTOR)!;
        fetch(Setup.API_BASE_PATH + 'changeBasketArticle', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'document': parseInt(documentUid, 10),
            'language': language,
            'quantity': parseInt(quantity, 10),
          }),
        })
          .then(response => response.json())
          .then(articleListsHtml => {
            articleList.innerHTML = articleListsHtml.articles;
            confirmArticleList.innerHTML = articleListsHtml.confirmationArticles;
            this.initModalListener(); // we have to reinitiv it, because list changes
          });
      });
    }

    // deleteBasketArticle
    const buttonDeleteBasketArticle = document.getElementsByClassName('js-button-delete-basket-article');
    for (let i = 0; i < buttonDeleteBasketArticle.length; i++) {
      buttonDeleteBasketArticle[i].addEventListener('click', event => {
        const documentUid = buttonDeleteBasketArticle[i].getAttribute('data-article-uid')!;
        const language = buttonDeleteBasketArticle[i].getAttribute('data-article-language')!;

        const articleList = document.querySelector(ARTICLE_LIST_QUERY_SELECTOR)!;
        const confirmArticleList = document.querySelector(CONFIRM_ARTICLE_LIST_QUERY_SELECTOR)!;
        fetch(Setup.API_BASE_PATH + 'deleteBasketArticle', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'document': parseInt(documentUid, 10),
            'language': language,
          }),
        })
          .then(response => response.json())
          .then(articleListsHtml => {

            const basketArticleCountSpans = document.querySelectorAll('.js-basket-article-count');
            basketArticleCountSpans.forEach(
              (basketArticleCountSpan: HTMLSpanElement) => basketArticleCountSpan.innerText = articleListsHtml.basketArticleCount.toString(),
            );

            articleList.innerHTML = articleListsHtml.articles;
            confirmArticleList.innerHTML = articleListsHtml.confirmationArticles;

            const submitButtonArticleList = document.getElementById('submit-button__article-list')! as HTMLButtonElement;
            submitButtonArticleList.disabled = (articleListsHtml.basketArticleCount === 0);

            this.initModalListener(); // we have to reinitiv it, because list changes
          });
      });
    }

    // submitBasket
    this.basketForm = document.getElementById('form-basket-articles')!;
    this.basketForm.addEventListener('submit', this.handleSubmitBasketFormListenerFunction);
  }

  private handleSubmitBasketFormListenerFunction(event) {
    // stop form submission
    event.preventDefault();

    // 'this' is the element in this scope TODO remove
    // if we want access to Basket function, we have to init the class here
    const basket = new Basket();

    const formData = new FormData(event.target as HTMLFormElement);

    const Http = new XMLHttpRequest();
    const url = '?tx_vrsdocumentshop_document%5Baction%5D=createOrder&tx_vrsdocumentshop_document%5Bcontroller%5D=Basket';
    // send request
    Http.open('POST', url);
    Http.send(formData);

    Http.onreadystatechange = function () {
      const response = this;

      // readyState 4: request is done
      if (this.readyState === 4) {
        // status 200: successfull, but not created -> Server Validation failed maybe
        if (this.status === 200) {
          // replace documentList Plugin html with new one (Error Modal with filled fields or success
          const documentshop = document.getElementById('documentshop')!;
          documentshop.outerHTML = response.responseText;

          // init js things again
          initDocumentShop();

          // open modal initially again
          basket.openModal();

          // show second tab
          const tabStepLinks = document.getElementsByClassName('js-basket-modal-tab-step-link');
          basket.showTab(tabStepLinks[0] as HTMLElement);
        } else if (this.status === 201) {
          // status 201: successfully created

          // show fourth tab
          const modalTab = document.getElementsByClassName('js-basket-modal-tab');
          basket.showTab(modalTab[3] as HTMLElement);

          // icons is always 0 after success

          const basketArticleCountSpans = document.querySelectorAll('.js-basket-article-count');
          basketArticleCountSpans.forEach(
            (basketArticleCountSpan: HTMLSpanElement) => basketArticleCountSpan.innerText = '0',
          );

          // stop this event called after success
          event.stopPropagation();
        }

        const alertDanger: HTMLElement = document.getElementById('js-modal-vrs-documentshop-basket-alert-danger')!;
        // alertHandling {
        if (this.status >= 400) {
          // Error, so show alert
          alertDanger.classList.remove('hide');
        } else {
          // no Error, so hide alert
          alertDanger.classList.add('hide');
        }
      }

      // enable submitButton again
      const submitButton: HTMLButtonElement = document.querySelector(SUBMIT_BUTTON_QUERY_SELECTOR)! as HTMLButtonElement;
      submitButton.disabled = false;
    };
  }
}
